import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicAddressingModes = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="ADDRESSING MODES"
      videos={[
        "https://www.youtube.com/embed/pQuRoq6xAK8",
        "https://www.youtube.com/embed/1FEPmCyj7O0",
      ]}
      takeaways={[
        { text: "Mostly they will ask theory questions to write with examples." },
      ]}
      questions={[]} // Added empty array
      exampleVideos={[]} // Added empty array
    />
);
}

export default ModuleSubtopicAddressingModes;
